/**
 *
 * @param value
 */
export default function isArray(value){
  return !!value && value.constructor === Array;
}
